import React from "react";
import { styled } from "@mui/system";
import MUIChip, { ChipProps } from "@mui/material/Chip";

export const Chip = styled((props: ChipProps) => <MUIChip {...props} />, {
  name: "Chip",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({
  "&.MuiChip-root": {
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    paddingRight: 6,
    background: theme.palette.primary.inputBackgroundDefault,
    border: "1px solid transparent",
    "&:hover": {
      background: theme.palette.primary.interactiveSelectedColor,
      "& .MuiChip-label": {
        fontweight: 500,
        fontSize: 14,
        color: theme.palette.primary.textTitleColor,
      },
      "& .MuiSvgIcon-root": {
        color: theme.palette.primary.textTitleColor,
        fontSize: 20,
      },
    },
    "&:active": {
      boxShadow: "none",
      border: "1px solid " + theme.palette.primary.borderActive,
      background: theme.palette.primary.interactiveSelectedColor,
      "& .MuiChip-label": {
        fontweight: 500,
        fontSize: 14,
        color: theme.palette.primary.textTitleColor,
      },
      "& .MuiSvgIcon-root": {
        color: theme.palette.primary.textTitleColor,
      },
    },
  },
  "&.MuiChip-root .MuiSvgIcon-root": {
    color: theme.palette.primary.textSubduedColor,
  },
  "&.MuiChip-root .MuiChip-deleteIcon": {
    fontSize: 20,
  },
  "&.MuiChip-root .MuiChip-icon": {
    fontSize: 14,
  },
  "&.MuiChip-root .MuiChip-label": {
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.primary.textSubduedColor,
  },

  "&.MuiChip-root.MuiChip-outlinedDefault": {
    border: "1px solid " + theme.palette.primary.borderActive,
    background: theme.palette.primary.interactiveSelectedColor,
    "& .MuiChip-label": {
      fontweight: 500,
      fontSize: 14,
      color: theme.palette.primary.textTitleColor,
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.primary.textTitleColor,
    },
  },
}));
